export const isFixedClassChangeNeeded = (
  hasFixedClass: boolean,
  shouldBeFixed: boolean
): boolean => hasFixedClass !== shouldBeFixed;
